/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Sku_Titan_HintInputs */



/**
* | output |
* | --- |
* | "Your own bot, priced by server size." |
*
* @param {Plan_Sku_Titan_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const plan_sku_titan_hint = /** @type {((inputs?: Plan_Sku_Titan_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Sku_Titan_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Собственный бот, цена зависит от размера сервера.")
	return /** @type {LocalizedString} */ ("Your own bot, priced by server size.")
});